export class ProjectPart {
  id: number = 0;
  requestKey: string = "";

  expanded: boolean = true;
  htmlId: string = "";


  constructor(
    name: string = "",
    id: number = 0,
    requestKey: string = "",
    expanded: boolean = true,
    prefix: string = ""
  ) {
    this.id = id;
    this.requestKey = requestKey;
    this.expanded = expanded;
    this.generateHtmlId(name, prefix);
  }

  public generateHtmlId(name: string = "", prefix: string = "") {
    if( this.id != 0 ) {
      this.htmlId = name + "-" + prefix + "-" + this.id;
    } else {
      this.htmlId = "" + new Date().getTime();
    }
  }
}
